import { render, staticRenderFns } from "./verticalMenu.vue?vue&type=template&id=a67e8482"
var script = {}
import style0 from "./verticalMenu.vue?vue&type=style&index=0&id=a67e8482&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports